<section class="simple-notes-wrapper">
	<div class="note-text" [innerHTML]="payload.notes"></div>
</section>
